export const SEARCH_PROMPT = 'Enter a departure port and region above to compare cruise sailings.';

export function hasSearchQuery(searchParams) {
  return Boolean(searchParams.get('port') || searchParams.get('destination'));
}
